import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const timeToCTDayWise = [
  { label: "Mon", avgTime: 22 },
  { label: "Tue", avgTime: 23 },
  { label: "Wed", avgTime: 21 },
  { label: "Thu", avgTime: 24 },
  { label: "Fri", avgTime: 25 },
  { label: "Sat", avgTime: 27 },
  { label: "Sun", avgTime: 26 },
];

/* Tooltip */
const CTTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;

  return (
    <div className="bg-white p-3 rounded-lg shadow-md border text-sm min-w-[160px]">
      <p className="font-semibold mb-1">{label}</p>
      <div className="flex justify-between font-semibold text-emerald-900">
        <span>Avg CT Time :</span>
        <span>{payload[0].value} min</span>
      </div>
    </div>
  );
};

export default function DoorToCTTimelineChart() {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart
        data={timeToCTDayWise}
        margin={{ top: 10, right: 10, left: -10, bottom: 0 }}
        barCategoryGap={"20%"}
      >
        {/* Dark Teal Gradient */}
        <defs>
          <linearGradient id="ctDarkGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#065F46" stopOpacity={0.45} />
            <stop offset="100%" stopColor="#065F46" stopOpacity={0} />
          </linearGradient>
        </defs>

        <CartesianGrid
          strokeDasharray="3 3"
          vertical={false}
          stroke="#e5e7eb"
        />

        <XAxis
          dataKey="label"
          tick={{ fontSize: 12 }}
          interval={0}
          stroke="#6b7280"
        />
        <YAxis
          tick={{ fontSize: 12 }}
          stroke="#6b7280"
          interval={0}
          tickFormatter={(v) => `${v}m`}
        />

        <Tooltip content={<CTTooltip />} />

        <Area
          type="monotone"
          dataKey="avgTime"
          stroke="#065F46"
          fill="url(#ctDarkGradient)"
          strokeWidth={3}
          dot={{
            r: 3,
            fill: "#065F46",
            stroke: "#065F46",
            strokeWidth: 3,
          }}
          activeDot={{ r: 3 }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
